<template>
  <div class="money-table">
    <div class="rank-box">
      <p class="mb10">职级<span style="color:#b8b8b8">（点开职级查看或编辑对应薪酬数字）</span></p>
      <div class="ranktag-box">
        <el-button v-for="(item, index) in professionalRank" :id="`professional${poperId}${index}`" :key="`professional${poperId}${index}`" class="mr10 mb10" size="mini" @click="showPoper(item, `professional${poperId}${index}`)" @dblclick.native="editRank(item, '专业')">
          {{ item.专业职级 }}
          <span class="close-text" @click="removeProfessionalRank(item)">x</span>
        </el-button>
        <el-button class="mr10 mb10" type="primary" size="mini" plain @click="addRow(`专业`)">
          +增加专业职级薪酬
        </el-button>
      </div>
      <div class="ranktag-box">
        <el-button v-for="(item, index) in managerialRank" :id="`managerial${poperId}${index}`" :key="`managerial${poperId}${index}`" class="mr10 mb10" size="mini" @click="showPoper(item, `managerial${poperId}${index}`)" @dblclick.native="editRank(item, '管理')">
          {{ item.管理职级 }}
          <span class="close-text" @click="removeManagerialRank(item)">x</span>
        </el-button>
        <el-button class="mr10 mb10" type="primary" size="mini" plain @click="addRow(`管理`)">
          +增加管理职级薪酬
        </el-button>
      </div>
    </div>
    <div class="text-box" style="width:100%;">
      <div v-for="item in textFields" :key="item" class="mb10">
        <p class="mb10">{{ item }}</p>
        <el-input v-model="table.content[item]" type="textarea" :rows="2" placeholder="请输入内容" @input="input"> </el-input>
      </div>
    </div>

    <!-- poper -->
    <Popper :id="`newMoneyTable${poperId}`" :visible.sync="popperVisible" style="z-index: 31;" :target-id="popperTarget" container="projectTableWrapper">
      <div class="money-table-popper">
        <p class="bolder">{{ activeRank.专业职级 || activeRank.管理职级 }}职级</p>
        <p>
          年限：<span class="bolder ml10">{{ activeRank.年限 }}</span>
        </p>
        <p>
          固薪：<span class="bolder ml10">{{ activeRank.固薪 }}</span>
        </p>
        <p>
          奖金：<span class="bolder ml10">{{ activeRank.奖金 }}</span>
        </p>
        <p>
          全薪：<span class="bolder ml10">{{ activeRank.全薪 }}</span>
        </p>
      </div>
    </Popper>

    <el-dialog title="添加职级" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" width="600px">
      <div>
        <span>职级（下拉选择，不可重复）</span>
        <el-cascader v-if="type === '专业'" v-model="newRank.职级" :options="prefessionalOptions" size="mini" @change="cascaderChange"></el-cascader>
        <el-select v-else v-model="newRank.职级" filterable size="mini" allow-create @change="selectRankChange">
          <el-option v-for="item in managerialOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </div>
      <div class="flex">
        <div class="left">
          <p class="mb10">该职级对应年限</p>
          <div>
            <el-input v-model="newRank.年限[0]" size="mini" class="short-input" placeholder="最低（数字）"></el-input>
            <span>年--</span>
            <el-input v-model="newRank.年限[1]" size="mini" class="short-input" placeholder="最高（数字）"></el-input>
            <span>年</span>
          </div>
          <p class="mb10">该职级对应固定薪酬（万/年）</p>
          <div>
            <el-input v-model="newRank.固薪[0]" size="mini" class="short-input" placeholder="最低（数字）"></el-input>
            <span>万--</span>
            <el-input v-model="newRank.固薪[1]" size="mini" class="short-input" placeholder="最高（数字）"></el-input>
            <span>万</span>
          </div>
          <p class="mb10">该职级对应奖金（万/年）</p>
          <div>
            <el-input v-model="newRank.奖金[0]" size="mini" class="short-input" placeholder="最低（数字）"></el-input>
            <span>万--</span>
            <el-input v-model="newRank.奖金[1]" size="mini" class="short-input" placeholder="最高（数字）"></el-input>
            <span>万</span>
          </div>
          <p class="mb10">该职级对应全年总薪酬（万/年）</p>
          <div>
            <el-input v-model="newRank.全薪[0]" size="mini" class="short-input" placeholder="最低（数字）"></el-input>
            <span>万--</span>
            <el-input v-model="newRank.全薪[1]" size="mini" class="short-input" placeholder="最高（数字）"></el-input>
            <span>万</span>
          </div>
        </div>
        <div class="right"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mr10" size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmEditRank">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import { moneyTable, moneyContent } from '../../statistics/variant/table'
import * as fixedvariant from '../../statistics/variant/fixedvariant'
import Popper from '../../../project/src/components/Popper'

const shortid = require('shortid')

const prefessionalSortMap = {}
const managerialSortMap = {}
const levels = ['MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
const options = [
  { label: 'ManagingPartner', value: 'ManagingPartner' },
  { label: 'Partner', value: 'Partner' },
]
levels.forEach((v) => {
  const obj = { label: v, value: v, children: [{ label: v, value: v }] }
  for (let i = 1; i < 5; i++) {
    obj.children.push({ label: `${v}${i}`, value: `${v}${i}` })
  }
  options.push(obj)
})

let sortNum = 1
for (let i = options.length; i > 0; i--) {
  const option = options[i - 1]
  if (option.children) {
    // eslint-disable-next-line no-loop-func
    option.children.forEach((v) => {
      prefessionalSortMap[v.value] = sortNum++
    })
  } else {
    prefessionalSortMap[option.value] = sortNum++
  }
}
fixedvariant.管理职级表头.forEach((val, index) => {
  managerialSortMap[val] = index + 1
})

export default {
  components: { Popper },
  props: {
    table: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      professionalRank: [],
      managerialRank: [],
      textFields: ['奖金机制', '奖金发放时间', '递延机制', '考核', '备注'],
      activeRank: {},
      popperVisible: false,
      popperTarget: null,
      poperId: '',
      dialogVisible: false,
      type: '',
      isAdmin: false,
      prefessionalOptions: options,
      managerialOptions: fixedvariant.管理职级表头,
      newRank: {
        职级: '',
        年限: ['', ''],
        固薪: ['', ''],
        奖金: ['', ''],
        全薪: ['', ''],
      },
    }
  },
  watch: {
    table: {
      handler(newVal, oldVal) {
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    // await this.setOption()
    // await this.getdata()
    this.poperId = shortid.generate()
    if (app.user && app.user.角色 && app.user.角色.includes('管理员')) this.isAdmin = true
  },
  methods: {
    input(val) {
      console.log(this.table.content)
    },
    removeProfessionalRank(rank) {
      this.$confirm('此操作将永久删除该职级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.professionalRank = this.professionalRank.filter((v) => v !== rank)
          this.table.table = this.table.table.filter((v) => v !== rank)
          this.$message.success('删除成功!')
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    removeManagerialRank(rank) {
      this.$confirm('此操作将永久删除该职级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.managerialRank = this.managerialRank.filter((v) => v !== rank)
          this.table.table = this.table.table.filter((v) => v !== rank)
          this.$message.success('删除成功!')
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    cascaderChange(val) {
      const rank = val[val.length - 1]
      if (!this.activeRankInEdit || rank !== this.activeRankInEdit[`专业职级`]) {
        const item = this.table.table.find((v) => v.专业职级 === rank)
        if (item) {
          const nianxian = (item['年限'] || '').split('-')
          const guxin = (item['固薪'] || '').split('-')
          const jiangjin = (item['奖金'] || '').split('-')
          const quanxin = (item['全薪'] || '').split('-')
          this.newRank = {
            职级: item['专业职级'],
            年限: [nianxian[0], nianxian.splice(1).join('')],
            固薪: [guxin[0], guxin.splice(1).join('')],
            奖金: [jiangjin[0], jiangjin.splice(1).join('')],
            全薪: [quanxin[0], quanxin.splice(1).join('')],
            type: 'update',
          }
          this.activeRankInEdit = item
        } else {
          this.newRank = {
            职级: rank,
            年限: ['', ''],
            固薪: ['', ''],
            奖金: ['', ''],
            全薪: ['', ''],
            type: 'insert',
          }
        }
      }
    },
    selectRankChange(val) {
      const rank = val
      if (!this.activeRankInEdit || rank !== this.activeRankInEdit[`管理职级`]) {
        // const item = this.table.table.find(v => v.管理职级 === rank)
        // if (item) {
        //   const nianxian = (item['年限'] || '').split('-')
        //   const guxin = (item['固薪'] || '').split('-')
        //   const jiangjin = (item['奖金'] || '').split('-')
        //   const quanxin = (item['全薪'] || '').split('-')
        //   this.newRank = {
        //     职级: item['管理职级'],
        //     年限: [nianxian[0], nianxian.splice(1).join('')],
        //     固薪: [guxin[0], guxin.splice(1).join('')],
        //     奖金: [jiangjin[0], jiangjin.splice(1).join('')],
        //     全薪: [quanxin[0], quanxin.splice(1).join('')],
        //     type: 'update',
        //   }
        //   this.activeRankInEdit = item
        // } else {
        this.newRank = {
          职级: rank,
          年限: ['', ''],
          固薪: ['', ''],
          奖金: ['', ''],
          全薪: ['', ''],
          type: 'insert',
        }
        // }
      }
    },
    init() {
      const { table } = this
      const professionalRank = ((table && table.table) || []).filter((v) => v.专业职级)
      const managerialRank = ((table && table.table) || []).filter((v) => v.管理职级)
      professionalRank.sort((a, b) => (prefessionalSortMap[a.专业职级] || 0) - (prefessionalSortMap[b.专业职级] || 0))
      managerialRank.sort((a, b) => (managerialSortMap[a.管理职级] || 100) - (managerialSortMap[b.管理职级] || 100))
      this.professionalRank = professionalRank
      this.managerialRank = managerialRank
    },
    showPoper(data, targetId) {
      this.activeRank = data
      this.popperVisible = true
      this.popperTarget = targetId
    },
    addRow(type) {
      this.type = type
      this.newRank = {
        职级: '',
        年限: ['', ''],
        固薪: ['', ''],
        奖金: ['', ''],
        全薪: ['', ''],
        type: 'insert',
      }
      this.activeRankInEdit = null
      this.dialogVisible = true
    },
    editRank(item, type) {
      this.type = type
      const nianxian = (item['年限'] || '').split('-')
      const guxin = (item['固薪'] || '').split('-')
      const jiangjin = (item['奖金'] || '').split('-')
      const quanxin = (item['全薪'] || '').split('-')
      this.newRank = {
        职级: type === '专业' ? item['专业职级'] : item['管理职级'],
        年限: [nianxian[0], nianxian.splice(1).join('')],
        固薪: [guxin[0], guxin.splice(1).join('')],
        奖金: [jiangjin[0], jiangjin.splice(1).join('')],
        全薪: [quanxin[0], quanxin.splice(1).join('')],
        type: 'update',
      }
      this.dialogVisible = true
      this.activeRankInEdit = item
    },
    confirmEditRank() {
      const { type, newRank } = this
      const fields = ['年限', '固薪', '奖金', '全薪']
      if (newRank.type === 'update') {
        if (type === '专业') {
          const rank = typeof newRank.职级 === 'string' ? newRank.职级 : newRank.职级[newRank.职级.length - 1]
          if (rank !== this.activeRankInEdit[`专业职级`]) {
            const has = this.table.table.find((v) => v.专业职级 === rank)
            if (has) return this.$message.error(`该职级已存在，无法修改为${rank}`)
          }
          this.activeRankInEdit[`专业职级`] = rank
        } else {
          if (newRank.职级 !== this.activeRankInEdit[`管理职级`]) {
            const has = this.table.table.find((v) => v.管理职级 === newRank.职级)
            if (has) return this.$message.error(`该职级已存在，无法修改为${newRank.职级}`)
          }
          this.activeRankInEdit[`管理职级`] = newRank.职级
        }
        fields.forEach((field) => {
          const arr = newRank[field].filter((v) => v)
          this.activeRankInEdit[field] = arr.join('-')
        })
        if (!this.activeRankInEdit[`专业职级`] && !this.activeRankInEdit[`管理职级`])
          return this.$message.error('请填写职级')
      } else {
        const obj = {}
        if (type === '专业') {
          obj[`专业职级`] = typeof newRank.职级 === 'string' ? newRank.职级 : newRank.职级[newRank.职级.length - 1]
        } else {
          obj[`管理职级`] = newRank.职级
        }
        fields.forEach((field) => {
          const arr = newRank[field].filter((v) => v)
          obj[field] = arr.join('-')
        })
        if (!obj[`专业职级`] && !obj[`管理职级`]) return this.$message.error('请填写职级')
        this.table.table.push(obj)
        this.init()
      }
      this.dialogVisible = false
    },
  },
}
</script>
<style>
.money-table .el-button + .el-button {
  margin-left: 0px;
}
</style>
<style scoped>
.ranktag-box {
  display: flex;
  flex-wrap: wrap;
}
pre {
  margin: 0;
  text-indent: 0;
  padding: 10px 15px;
  background-color: #f7f9fc;
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.5;
  color: #262626;
  position: relative;
}
.money-table-popper {
  padding: 10px 20px;
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.close-text {
  color: #409eff;
  margin-left: 10px;
}
.bolder {
  font-weight: 700;
}
.short-input {
  width: 50px;
  margin-right: 4px;
}
.flex {
  display: flex;
}
.left {
  width: 60%;
}
.right {
  width: 40%;
}
</style>
